import React, {useContext, useEffect} from 'react'
import {OfferContext} from "../../../context/OfferContext";
import {Form, InputNumber} from "antd";

const OfferCreateQuantity = ({rowIndex, record}) => {
    const [form] = Form.useForm()
    const {materialInformation} = useContext(OfferContext)
    const [materials, setMaterials] = materialInformation

    useEffect(() => {
        form.setFieldsValue({
            [`${rowIndex}-quantity`]: record.quantity
        })
    })

    const handleQuantityChange = ({target}) => {
        let mockContext = [...materials]
        mockContext[rowIndex].quantity = target.value
        setMaterials(mockContext)
    }

    return(
        <React.Fragment>
            <Form
                form={form}
            >
                <Form.Item
                    name={`${rowIndex}-quantity`}
                >
                    <InputNumber
                        disabled={!record.data}
                        step={0.1}
                        onBlur={handleQuantityChange}
                    />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferCreateQuantity